import { LayoutWithSidebar } from 'utils/router/components/LayoutWithSidebar/LayoutWithSidebar'
import { getHandle } from 'utils/router/utils/getHandle'

export const CmsRoutes = [
  {
    path: 'cms',
    Component: LayoutWithSidebar,
    alias: 'cms',
    query: ['path', 'field', 'order', 'search', 'triggerFilters', 'triggerStatus'],
    children: [
      {
        suspense: true,
        index: true,
        lazy: () => import('apps/cms/pages/ContentManagementSystem/ContentManagementSystem'),
      },
      {
        suspense: true,
        path: 'files/:fso_path/:mode?/:content_id?',
        alias: 'cmsFiles',
        query: ['preset', 'sessionId', 'openTriggerId'],
        handle: getHandle('flow'),
        lazy: () => import('./cms-builder.page'),
      },
      {
        path: 'quick-automations/:fso_path/:mode?',
        alias: 'cmsQuickAutomation',
        lazy: () => import('./quick-automation.page'),
      },
      {
        path: 'ai-step-automation',
        alias: 'aiStepWizard',
        lazy: () => import('common/cms/pages/ai-step-wizard.page'),
      },
      {
        path: '#rules',
        lazy: () => import('apps/triggerRules/pages/rulesList.page'),
      },
      {
        path: 'easy-builder/:flow_id?',
        alias: 'easyBuilder',
        query: ['folder_id', 'campaign_type', 'source', 'options', 'anchor_id', 'post_id'],
        handle: { requiresAuth: true, skipForMobile: 'Dashboard' },
        lazy: () => import('common/cms/pages/easy-builder.page'),
      },
    ],
  },
  {
    path: 'rules/:rule_id',
    Component: LayoutWithSidebar,
    alias: 'ruleItem',
    children: [
      {
        index: true,
        lazy: () => import('apps/triggerRules/pages/ruleDetail.page'),
      },
    ],
  },
] as const
